// src/scheduling/components/view-appointment-panel/vitals/lmp-flags.ts
// The LMP row's flags, shared by every vitals editor (the appointment panel's tab and the PE inline grid). Its own
// module, not lmp-editor.tsx: a component file exports components only (react-refresh).
import { NOT_MENSTRUATING_VALUE } from './lmp-editor';

/**
 * The "currently menstruating" flag an editor starts from, read off the stored LMP reading (D-5101, after the PROD-3130
 * review). The stored flag wins. With no flag, the stored VALUE decides: "Not menstruating" means not menstruating, so
 * the editor never opens showing "menstruating" next to that value, and the next save never sends the two together.
 * Anything else with no flag (a date, a blank, no reading) starts as menstruating, as before (Flutter's model treats a
 * missing isMenstrual as true).
 */
export function lmpIsMenstrualFrom(
  reading: { isMenstrual?: boolean | null; quantity?: { value?: string | null } | null } | null | undefined,
): boolean {
  return reading?.isMenstrual ?? reading?.quantity?.value !== NOT_MENSTRUATING_VALUE;
}
